<template>
  <div>
    <c-row>
      <c-col col="12">
        <c-card>
          <loader v-show="loading" />
          <c-card-header>
            <strong>Transaksi Berhasil</strong>
            <div class="card-header-actions" v-show="isSearch">
              <CInput @keyup="doSearch" type="text" placeholder="Ketikan sesuatu kemudian tekan enter" v-model="q"
                style="width: 400px" ref="search">
                <template #append-content>
                  <a @click="hideSearch">
                    <i class="cil-chevron-circle-right-alt"></i>
                  </a>
                </template>
              </CInput>
            </div>
            <div class="card-header-actions" v-show="!isSearch">
              <a class="link btn btn-outline-info" @click="showSearch">
                <i class="cil-search"></i>
              </a>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Faktur</th>
                  <th>Supplier</th>
                  <th>Created By</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td>
                    <table-number :index="k" :paginate="data.paginate" />
                  </td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.supplier_name }}</td>
                  <td>{{ d.user_name }}</td>
                  <td>{{ d.created_at | dateTimeFormat }}</td>
                  <td class="center" width="80px">
                    <button class="btn-outline-info btn btn-action" v-c-tooltip.click="'Preview'" @click="doApprove(d)">
                      <i class="cil-magnifying-glass"></i>
                    </button>
                    <button class="btn-outline-success btn btn-action" v-c-tooltip.click="'Approve'"
                      @click="doApprove(d)">
                      <i class="cil-check"></i>
                    </button>
                    <button class="btn-outline-warning btn btn-action" v-c-tooltip.click="'Edit'" @click="doEdit(d)">
                      <i class="cil-pencil"></i>
                    </button>
                    <button class="btn-outline-danger btn btn-action" v-c-tooltip.click="'Delete'" @click="doDelete(d)">
                      <i class="cil-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import TableNumber from '../../components/TableNumber.vue'
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from '../../lib/httplib'

export default {
  components: {
    TableNumber,
    Loader,
  },
  data () {
    return {
      data: {},
      isSearch: false,
      q: '',
      loading: true
    };
  },
  created () {
    this.list()
  },
  methods: {
    hideSearch () {
      this.isSearch = false;
      this.$router.push({ query: { search: false } });
      this.q = "";
    },
    showSearch () {
      this.isSearch = true;
      this.$router.push({ query: { search: true } });
    },
    doSearch (e) {
      if (e.keyCode === 13) {
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    list () {
      this.loading = true
      HTTPAUTH.get(`/api/v1/po/process`).then(res => {
        this.loading = false
        this.data = res.data;
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false
      })
    },
    addNew () { },
    doApprove (v) {
      this.$router.push({ path: `/po/preview/${v.id}?preview=true&rollback=/po/process&printurl=/print/po/faktur` }).catch(() => { })
    },
    doEdit (v) {
      this.$router.push({ path: `/po?id=${v.id}` }).catch(() => { })
    },
    doDelete (v) {
      this.loading = true
      const c = confirm(`Yakin akan menghapush data po "${v.faktur}" ?`);
      if (c) {
        HTTPAUTH.delete(`/api/v1/po/${v.id}`).then(() => {
          this.$toasted.show(`Data berhasil dihapus`).goAway(1000);
          this.list();
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
};
</script>